import Link from 'next/link';
import { t } from 'i18next';
// components
import { Nav } from 'rsuite';
import { ExButton } from '@commons/EXComponentsLibrary';
// utils && hooks
import * as gtag from 'utils/gtag';
// styles
import styles from './NavBar.module.css';

const NavBar = ({ active, query, userCanUseCommercialAgreements, withoutAgreement }) => {
    return (
        <Nav activeKey={active} appearance="subtle" className={styles['nav']}>
            <Nav.Item as={Link} href={`/${query?.clientId}/settings/POS`} eventKey="POS" className={styles['item']}>
                {t('settings.commercialAgreements.sett_tabPointsOfSale')}
            </Nav.Item>
            {userCanUseCommercialAgreements() && (
                <Nav.Item
                    as={Link}
                    href={`/${query?.clientId}/settings/trade-agreements`}
                    eventKey="trade-agreements"
                    className={styles['item']}
                >
                    {t('settings.commercialAgreements.sett_tabCommercialAgreements')}
                </Nav.Item>
            )}
            {active === 'trade-agreements' && !withoutAgreement && (
                <div className={styles['create-agreement-button']}>
                    <Link
                        href={`/${query?.clientId}/settings/trade-agreements/create`}
                        onClick={() => {
                            // Add gtag event
                            gtag.event({
                                action: 'click',
                                category: 'config__commercial-agreements',
                                label: 'button__create-agreement-1',
                                value: 0,
                            });
                        }}
                        style={{ textDecoration: 'none' }}
                    >
                        <ExButton>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                            >
                                <path
                                    d="M7.3335 8.66671H4.00016C3.81127 8.66671 3.65294 8.60282 3.52516 8.47504C3.39738 8.34726 3.3335 8.18893 3.3335 8.00004C3.3335 7.81115 3.39738 7.65282 3.52516 7.52504C3.65294 7.39726 3.81127 7.33337 4.00016 7.33337H7.3335V4.00004C7.3335 3.81115 7.39739 3.65282 7.52516 3.52504C7.65294 3.39726 7.81127 3.33337 8.00016 3.33337C8.18905 3.33337 8.34739 3.39726 8.47516 3.52504C8.60294 3.65282 8.66683 3.81115 8.66683 4.00004V7.33337H12.0002C12.1891 7.33337 12.3474 7.39726 12.4752 7.52504C12.6029 7.65282 12.6668 7.81115 12.6668 8.00004C12.6668 8.18893 12.6029 8.34726 12.4752 8.47504C12.3474 8.60282 12.1891 8.66671 12.0002 8.66671H8.66683V12C8.66683 12.1889 8.60294 12.3473 8.47516 12.475C8.34739 12.6028 8.18905 12.6667 8.00016 12.6667C7.81127 12.6667 7.65294 12.6028 7.52516 12.475C7.39739 12.3473 7.3335 12.1889 7.3335 12V8.66671Z"
                                    fill="white"
                                />
                            </svg>
                            <p>{t('settings.commercialAgreements.sett_buttonComercialAgreements')}</p>
                        </ExButton>
                    </Link>
                </div>
            )}
        </Nav>
    );
};

export default NavBar;
